export enum LocationType {
    Office = 0,
    Home,
    Telephone,
    Video,
}
